<template>
    <div class="carousel-control container1">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="large-image-section" :class="{'has-multiple-images': this.collection?.length > 1}">

                    <div class="carousel-container">
                        <CarouselImageLarge :src="this.collection[item_index].url"
                                            :srcset="this.collection[item_index].url"
                                            :placeholder="this.collection[item_index].url"
                                            :aspect-ratio-width="aspectRatioWidth"
                                            :aspect-ratio-height="aspectRatioHeight"
                                            :alt="this.collection[item_index].altText"
                                            v-if="this.collection?.length>0" />
                    </div>
                    <div class="button-container" v-if="this.collection?.length>1">
                        <button class="btn chevron chevron-left previous-slide-button" @click="item_index <= 0 ? (item_index = this.collection?.length-1) : item_index--">
                            <span class="sr-only">Previous Slide</span>
                        </button>
                        <button class="btn chevron chevron-right next-slide-button" @click="item_index== this.collection?.length-1 ? (item_index = 0) : item_index++">
                            <span class="sr-only">Next Slide</span>
                        </button>
                    </div>
                </div>
                <div class="d-none d-md-block thumbnail-container" v-if="this.collection?.length>1">
                    <div class="gallery-container">
                        <div v-for="(image, index) in this.collection"
                             :key="index"
                             class="gallery-item">
                            <CarouselImageThumbnail :src="image.url"
                                                    :alt="image.altText"
                                                    @click="item_index = index"
                                                    :aspect-ratio-width="aspectRatioWidth" 
                                                    :aspect-ratio-height="aspectRatioHeight"
                                                    />
                        </div>
                    </div>
                    <div class="thumbnail-btn-container">
                        <button class="button btn chevron chevron-left previous-slide-button" @click="moveleft()"> <span class="sr-only">Previous Slide</span> </button>
                        <button class="btn chevron chevron-right next-slide-button" @click="moveright()"> <span class="sr-only">Next Slide</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CarouselImageLarge from "./CarouselImageLarge.vue";
    import CarouselImageThumbnail from "./CarouselImageThumbnail.vue";
    import {brandCrest} from '../constants/labels.config'
    export default {
        name: "CarouselControl",
        components: {
            CarouselImageLarge,
            CarouselImageThumbnail,
        },
        props:["imagesCollection","model", "aspectRatioWidth", "aspectRatioHeight"],
        data() {
            return {
                item_index: 0,
                collection:null,
                brandCrest,
            };
        },
        methods: {
            moveleft() {
                let content = document.querySelector(".gallery-container");
                content.scrollLeft -= 100;
            },
            moveright() {
                let content = document.querySelector(".gallery-container");
                content.scrollLeft += 100;
            },
            getImgUrl(model) {
                if (window.BRAND.toLowerCase()!==this.brandCrest.toLowerCase())
                {
                    return "/img/boats/PlaceholderImages/MasterCraft/view_boat_details.jpg";
                }
                else{                    
                    if(model!==undefined || model!==null || model.toLowerCase()!=='')
                    {          
                        if(model.toLowerCase().includes('caribbean lx'))                                      
                            return "/img/boats/PlaceholderImages/Crest/Caribbean LX.png";
                        else if(model.toLowerCase().includes('caribbean platinum')) 
                            return "/img/boats/PlaceholderImages/Crest/Caribbean Platinum.png";
                        else if(model.toLowerCase().includes('caribbean rs')) 
                            return "/img/boats/PlaceholderImages/Crest/Caribbean RS.png";
                        else if(model.toLowerCase().includes('classic dlx')) 
                            return "/img/boats/PlaceholderImages/Crest/Classic DLX.png";
                        else if(model.toLowerCase().includes('classic lx')) 
                            return "/img/boats/PlaceholderImages/Crest/Classic LX.png";
                        else if(model.toLowerCase().includes('classic platinum')) 
                            return "/img/boats/PlaceholderImages/Crest/Classic Platinum.png";
                        else if(model.toLowerCase().includes('continental nx')) 
                            return "/img/boats/PlaceholderImages/Crest/Continental NX.png";
                        else if(model.toLowerCase().includes('continental')) 
                            return "/img/boats/PlaceholderImages/Crest/Continental.png";
                        else if(model.toLowerCase().includes('savannah')) 
                            return "/img/boats/PlaceholderImages/Crest/Savannah.png";
                        else 
                            return "/img/boats/PlaceholderImages/Crest/Caribbean LX.png";
                    }
                    else
                    {
                        return "/img/boats/PlaceholderImages/Crest/Caribbean LX.png";
                    }
                }
            },            
            getDefaultObj()
            {
               return [{
                    url: this.getImgUrl(this.model),
                    altText: `${this.model} default`,
                }];
            }
        },
        mounted(){
            let a=this;
            if(a.imagesCollection===undefined || a.imagesCollection===null || a.imagesCollection?.length===0)
            {
                a.collection=a.getDefaultObj();
            }
            else{
                let tempCollection=[];
                a.imagesCollection.forEach((img)=>{
                        if(img.url!==undefined && img.url!==null && img.url!=='')
                    {
                        tempCollection.push(img);
                    }
                });

                a.collection=tempCollection?.length>0 ? tempCollection : a.getDefaultObj();
            }
            console.log(a.collection);
        }
    };
</script>

<style scoped lang="scss">
    .carousel-control {
        .gallery-item {
            display: inline-block;
            z-index: 2;
        }

        .gallery-container {
            overflow-x: scroll;
            overflow-y: hidden;
            scroll-snap-type: x mandatory;
            scroll-behavior: smooth;
            display: flex;
            width: 100%;
            -ms-overflow-style: none; /* Internet Explorer 10+ */
            scrollbar-width: none; /* Firefox */

            @media screen and (min-width: 200px) {
                overflow-y: scroll;
                overflow-x: hidden;
                scroll-snap-type: y mandatory;
            }

            &::-webkit-scrollbar {
                display: none; /* Safari and Chrome */
            }
        }

        .large-image-section {
            display: block;
            position: relative;

            &.has-multiple-images {
                padding-left: 30px;
                padding-right: 30px;
            }
        }

        .container {
            margin: 2%;
        }

        .button-container, .thumbnail-btn-container {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            height: 20px;

            .next-slide-button {
                position: absolute;
                right: 0px;
            }

            .previous-slide-button {
                position: absolute;
                left: 0px;
            }
        }

        .thumbnail-container {
            padding-left: 30px;
            padding-right: 30px;
            position: relative;
        }

        .carousel-container {
            width: 100%;
            margin-top: 2%;
        }
        /*Chevron (Arrow)*/
        .btn {
            color: black;
        }

        .chevron {
            position: relative;
            display: block;
            width: 20px;
            height: 20px;
            cursor: pointer;
            opacity: 1;
            transition: all .2s ease-in;
            background: transparent;
        }
        /*Draw the arrow*/
        .chevron::after {
            position: absolute;
            top: 5px;
            right: 7px;
            content: '';
            border-right: 1px solid;
            border-bottom: 1px solid;
            transform: rotate(-45deg);
            width: 12px;
            height: 12px;
            vertical-align: middle;
        }

        .chevron.chevron-right {
            transform: rotate(0deg);
        }

        .chevron.chevron-left {
            transform: rotate(180deg);
        }

        .chevron.chevron-left::after {
            top: 3px;
        }

        .chevron.chevron-bottom {
            transform: rotate(90deg);
        }

        .chevron.chevron-top {
            transform: rotate(-90deg);
        }
        /*End of icons*/
    }
</style>
